module.exports = __webpack_public_path__ + "img/album03_09.71e2ab59.jpg";